import React, { Component } from "react";
import { connect } from "react-redux";
import { changeView, setSportDemographics } from "./../actions/assessment";

import { SaveUserStateToServerHelper } from "./Helper";
import DemographicOptions from "./DemographicOptions";
import SportDemographicOptions from "./SportDemographicOptions";
import { Modal } from "react-bootstrap";
import warningIcon from "./../assets/img/icon-warning.svg";

import { Translate } from "react-redux-i18n";
import Button from "./ui/Buttons/Button";

export class SportDemographic extends Component {
  state = {
    sport: null,
    position: null,
    level: null,
    gender: null,
    show_modal: false,
    modal_message: "",
  };

  componentDidMount() {
    SaveUserStateToServerHelper(this.props.assessment);
  }

  setSport = (value) => {
    if (value !== "") {
      value = parseInt(value);
    }
    this.setState({ sport: value });
  };

  setPosition = (value) => {
    if (value !== "") {
      value = parseInt(value);
    }
    this.setState({ position: value });
  };

  setLevel = (value) => {
    if (value !== "") {
      value = parseInt(value);
    }
    this.setState({ level: value });
  };

  setGender = (value) => {
    if (value !== "") {
      value = parseInt(value);
    }
    this.setState({ gender: value });
  };

  isValidField = (value, fieldName) => {
    if (value === null || value === "") {
      this.setState({
        show_modal: true,
        modal_message: <Translate value="select_demo" field={fieldName} />,
      });
      return false;
    }

    return true;
  };

  closeModal = () => {
    this.setState({ show_modal: false });
  };

  submitSportDemographic = () => {
    const { sport, position, level, gender } = this.state;

    if (
      this.isValidField(sport, <Translate value="sport" />) &&
      this.isValidField(level, <Translate value="level" />) &&
      this.isValidField(gender, <Translate value="gender" />)
    ) {
      this.props.setSportDemographics(sport, position, level, gender);

      return this.props.view_session();
    }

    return false;
  };

  render() {
    const i18n = require("react-redux-i18n").I18n;

    return (
      <div>
        <div className="main container-fluid h-100">
          <div className="row justify-content-center align-items-center">
            <div className="col-12">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-6">
                    <div className="test-info">
                      <h3 className="mt-4 mb-5 text-center">
                        <Translate value="sport_info" />
                      </h3>
                      <small>
                        <p class="text-justify mb-3">
                          <Translate value="sport_intro" />
                        </p>
                      </small>

                      <SportDemographicOptions
                        data={this.props.sport_demographic_fields.sports}
                        getSport={this.setSport}
                        getPosition={this.setPosition}
                      />

                      <DemographicOptions
                        name="level"
                        label={i18n.t("level")}
                        options={this.props.sport_demographic_fields.level}
                        demographicOnChange={this.setLevel}
                      />

                      <DemographicOptions
                        name="gender"
                        label={i18n.t("gender")}
                        options={this.props.sport_demographic_fields.gender}
                        demographicOnChange={this.setGender}
                      />

                      <div className="button-wrap mt-4">
                        {/* <button
                          className="btn btn-main btn-global btn-block"
                          onClick={this.submitSportDemographic}
                        >
                          <Translate value="submit" />
                        </button> */}
                        <Button
                          variant="primary"
                          className="btn-global btn-block"
                          onClick={this.submitSportDemographic}
                        >
                          <Translate value="submit" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={this.state.show_modal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <div className="text-center mt-5 mb-5">
              <img src={warningIcon} className="icon" alt={i18n.t("expired")} />
              <br />
              <br />
              {/* <h2 className="title">
                Warning
              </h2> */}
              <p>{this.state.modal_message}</p>

              <div className="button-wrap mt-md-5">
                <button
                  className="btn btn-success btn-sm"
                  // data-dismiss="modal"
                  onClick={this.closeModal}
                >
                  <Translate value="close" />
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  demographic_fields: state.assessment.demographic_fields,
  sport_demographic_fields: state.assessment.sport_demographic_fields,
});

const mapDispatchToProps = (dispatch) => ({
  view_session: () => dispatch(changeView("session_details")),
  setSportDemographics: (sport, position, level, gender) =>
    dispatch(setSportDemographics(sport, position, level, gender)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SportDemographic);
